import { createBooleanQuery } from '../utils'
import { createSharedComposable } from '@vueuse/core'

export const useShowRegions = createSharedComposable(() => {
    return createBooleanQuery('show-regions')
})
